// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { roleTypeLabel, roleTypes } from '../../../../components/sp-role-type/sp-role-type.exports';

export class Controller {

    /** @ngInject */
    constructor($filter, Alert, DestructiveOperationModal, RoleResource) {
        this.$filter = $filter;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.RoleResource = RoleResource;
    }

    $onInit() {
        this.st = new SmartTable();
        this.filter = {
            roleType: undefined,
        };
        this.roleTypes = [undefined, ...roleTypes];
        this.fiterByRoleType();
    }

    fiterByRoleType(roleType) {
        this.filter.roleType = roleType;
        this.filteredAdministrators = this.$filter('filter')(this.administrators, this.filter);
    }

    removeAdministrator({id}) {
        this.DestructiveOperationModal({
            titleKey: 'company.administrators.remove.title',
            textKey: 'company.administrators.remove.are-you-sure',
            onSubmit: params => this.RoleResource.removeRoleInCompany(this.companyId, id, params)
        }).then(() => {
            this.Alert('success', 'company.administrators.remove.removed');
            const index = this.administrators.findIndex(a => a.id === id);
            this.administrators.splice(index, 1);
            this.$onInit();
        });
    }

    roleTypeLabel(roleType) {
        return roleType ? roleTypeLabel(roleType) : 'global.filter.all';
    }

    unblockAdministrator({id}) {
        this.DestructiveOperationModal({
            titleKey: 'company.administrators.unblock.title',
            onSubmit: params => this.RoleResource.unblockUserInCompany(this.companyId, id, params)
        }).then(() => {
            this.Alert('success', 'company.administrators.unblock.unblocked');
            this.administrators.find(a => a.id === id).blockedType = 'NONE';
        });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/list/administrators-list.controller.js